import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: string; output: string };
  Identifier: { input: string; output: string };
  Upload: { input: File; output: File };
};

export type MatchResult = {
  __typename?: "MatchResult";
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  scores: Maybe<MatchScores>;
};

export type MatchScores = {
  __typename?: "MatchScores";
  country: Maybe<Scalars["Int"]["output"]>;
  duns: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["Int"]["output"]>;
  url: Maybe<Scalars["Int"]["output"]>;
};

export type RematchResult = {
  __typename?: "RematchResult";
  filesQueued: Maybe<Scalars["Int"]["output"]>;
};

export type RootQueryType = {
  __typename?: "RootQueryType";
  /** Match a singular row */
  match: Maybe<MatchResult>;
  /** Rematch a singular file or all files */
  rematch: Maybe<RematchResult>;
  /** Gather Match File's meta data */
  stats: Maybe<UploadResult>;
  /** Parse File and match */
  upload: Maybe<UploadResult>;
};

export type RootQueryTypeMatchArgs = {
  country?: InputMaybe<Scalars["String"]["input"]>;
  customerCompanyId?: InputMaybe<Scalars["String"]["input"]>;
  duns?: InputMaybe<Scalars["String"]["input"]>;
  enforceCountryMatch?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPlatformPermissible?: InputMaybe<Scalars["Boolean"]["input"]>;
  isV1Dataset?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  rgifExclusiveCompany?: InputMaybe<Scalars["Boolean"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootQueryTypeRematchArgs = {
  fileIds: Array<InputMaybe<Scalars["Identifier"]["input"]>>;
  isPlatformPermissible?: InputMaybe<Scalars["Boolean"]["input"]>;
  isV1Dataset?: InputMaybe<Scalars["Boolean"]["input"]>;
  rgifExclusiveCompany?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RootQueryTypeStatsArgs = {
  fileId: Scalars["Identifier"]["input"];
};

export type RootQueryTypeUploadArgs = {
  enforceCountryMatch?: InputMaybe<Scalars["Boolean"]["input"]>;
  file: Scalars["Upload"]["input"];
  isPlatformPermissible?: InputMaybe<Scalars["Boolean"]["input"]>;
  isV1Dataset?: InputMaybe<Scalars["Boolean"]["input"]>;
  rgifExclusiveCompany?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UploadResult = {
  __typename?: "UploadResult";
  errorMessage: Maybe<Scalars["String"]["output"]>;
  fileId: Maybe<Scalars["Identifier"]["output"]>;
  fileName: Maybe<Scalars["String"]["output"]>;
  invalidRows: Maybe<Scalars["Int"]["output"]>;
  isPlatformPermissible: Maybe<Scalars["Boolean"]["output"]>;
  isV1Dataset: Maybe<Scalars["Boolean"]["output"]>;
  lastMatched: Maybe<Scalars["DateTime"]["output"]>;
  matchedRows: Maybe<Scalars["Int"]["output"]>;
  matchedWith: Maybe<Scalars["String"]["output"]>;
  presignedUrl: Maybe<Scalars["String"]["output"]>;
  processedChunks: Maybe<Scalars["Int"]["output"]>;
  rgifExclusiveCompany: Maybe<Scalars["Boolean"]["output"]>;
  salesLosses: Maybe<Scalars["Int"]["output"]>;
  salesWins: Maybe<Scalars["Int"]["output"]>;
  status: Maybe<Scalars["String"]["output"]>;
  totalChunks: Maybe<Scalars["Int"]["output"]>;
  totalRows: Maybe<Scalars["Int"]["output"]>;
  uploaded: Maybe<Scalars["DateTime"]["output"]>;
};

export type StatsQueryVariables = Exact<{
  fileId: Scalars["Identifier"]["input"];
}>;

export type StatsQuery = {
  __typename?: "RootQueryType";
  stats: {
    __typename?: "UploadResult";
    fileId: string | null;
    fileName: string | null;
    uploaded: string | null;
    lastMatched: string | null;
    totalChunks: number | null;
    processedChunks: number | null;
    totalRows: number | null;
    matchedRows: number | null;
    invalidRows: number | null;
    salesWins: number | null;
    salesLosses: number | null;
    isPlatformPermissible: boolean | null;
    isV1Dataset: boolean | null;
    rgifExclusiveCompany: boolean | null;
  } | null;
};

export type UploadQueryVariables = Exact<{
  file: Scalars["Upload"]["input"];
  isPlatformPermissible: Scalars["Boolean"]["input"];
  isV1Dataset?: InputMaybe<Scalars["Boolean"]["input"]>;
  rgifExclusiveCompany?: InputMaybe<Scalars["Boolean"]["input"]>;
  enforceCountryMatch?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UploadQuery = {
  __typename?: "RootQueryType";
  upload: {
    __typename?: "UploadResult";
    fileId: string | null;
    fileName: string | null;
    uploaded: string | null;
    lastMatched: string | null;
    totalChunks: number | null;
    processedChunks: number | null;
    totalRows: number | null;
    isPlatformPermissible: boolean | null;
    salesWins: number | null;
    salesLosses: number | null;
  } | null;
};

export const StatsDocument = gql`
  query Stats($fileId: Identifier!) {
    stats(fileId: $fileId) {
      fileId
      fileName
      uploaded
      lastMatched
      totalChunks
      processedChunks
      totalRows
      matchedRows
      invalidRows
      salesWins
      salesLosses
      isPlatformPermissible
      isV1Dataset
      rgifExclusiveCompany
    }
  }
`;

/**
 * __useStatsQuery__
 *
 * To run a query within a React component, call `useStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatsQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useStatsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    StatsQuery,
    StatsQueryVariables
  > &
    ({ variables: StatsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<StatsQuery, StatsQueryVariables>(
    StatsDocument,
    options
  );
}
export function useStatsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    StatsQuery,
    StatsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<StatsQuery, StatsQueryVariables>(
    StatsDocument,
    options
  );
}
export function useStatsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<StatsQuery, StatsQueryVariables>
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<StatsQuery, StatsQueryVariables>(
    StatsDocument,
    options
  );
}
export type StatsQueryHookResult = ReturnType<typeof useStatsQuery>;
export type StatsLazyQueryHookResult = ReturnType<typeof useStatsLazyQuery>;
export type StatsSuspenseQueryHookResult = ReturnType<
  typeof useStatsSuspenseQuery
>;
export type StatsQueryResult = Apollo.QueryResult<
  StatsQuery,
  StatsQueryVariables
>;
export const UploadDocument = gql`
  query Upload(
    $file: Upload!
    $isPlatformPermissible: Boolean!
    $isV1Dataset: Boolean
    $rgifExclusiveCompany: Boolean
    $enforceCountryMatch: Boolean
  ) {
    upload(
      file: $file
      isPlatformPermissible: $isPlatformPermissible
      isV1Dataset: $isV1Dataset
      rgifExclusiveCompany: $rgifExclusiveCompany
      enforceCountryMatch: $enforceCountryMatch
    ) {
      fileId
      fileName
      uploaded
      lastMatched
      totalChunks
      processedChunks
      totalRows
      isPlatformPermissible
      salesWins
      salesLosses
    }
  }
`;

/**
 * __useUploadQuery__
 *
 * To run a query within a React component, call `useUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadQuery({
 *   variables: {
 *      file: // value for 'file'
 *      isPlatformPermissible: // value for 'isPlatformPermissible'
 *      isV1Dataset: // value for 'isV1Dataset'
 *      rgifExclusiveCompany: // value for 'rgifExclusiveCompany'
 *      enforceCountryMatch: // value for 'enforceCountryMatch'
 *   },
 * });
 */
export function useUploadQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    UploadQuery,
    UploadQueryVariables
  > &
    ({ variables: UploadQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<UploadQuery, UploadQueryVariables>(
    UploadDocument,
    options
  );
}
export function useUploadLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UploadQuery,
    UploadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<UploadQuery, UploadQueryVariables>(
    UploadDocument,
    options
  );
}
export function useUploadSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UploadQuery,
        UploadQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<UploadQuery, UploadQueryVariables>(
    UploadDocument,
    options
  );
}
export type UploadQueryHookResult = ReturnType<typeof useUploadQuery>;
export type UploadLazyQueryHookResult = ReturnType<typeof useUploadLazyQuery>;
export type UploadSuspenseQueryHookResult = ReturnType<
  typeof useUploadSuspenseQuery
>;
export type UploadQueryResult = Apollo.QueryResult<
  UploadQuery,
  UploadQueryVariables
>;
